import * as React from "react";
const formStyles = require("./style.less");

interface NoteProps {
    style?: any;
    checkboxNote?: boolean;
}

const Note: React.StatelessComponent<NoteProps> = props => {
    const style =  props.checkboxNote ? {marginLeft: "40px"} : {};
    return <div className={formStyles.note} style={props.style}>{props.children}</div>;

};

export default Note;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/Note/Note.tsx